import dayjs from 'dayjs';

export const formatAMPMHour = (hour) => {
  const globalTime = dayjs().format('YYYY-MM-DD');

  return dayjs(globalTime + hour).format('h:mm a');
};
